import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import TableJobFamily from 'modules/pages/dacum/schoolManagement/TableJobFamily';
import React from 'react';

const SchoolJobFamilyPage = () => {
  return (
    <Container fluid>
      <Stack>
        <PageTitle title='School Job Family' />
        <TableJobFamily />
      </Stack>
    </Container>
  );
};

export default SchoolJobFamilyPage;
